const Pagination = {
  defaultProps: {},
  styleOverrides: {
    ul: () => ({
      flexWrap: "nowrap",
    }),
  },
};

export default Pagination;
